{
  "navigation": {
    "active": "Active",
    "resolved": "Resolved"
  },
  "page_title": "Alerts",
  "severity": {
    "high": "High",
    "low": "Low",
    "medium": "Medium",
    "site-outage": "Down"
  },
  "table": {
    "api_error": "There was an error loading alerts",
    "columns": {
      "active_for": "Active For",
      "circuit": "Circuit",
      "circuit_usage": "Circuit usage",
      "company": "Company",
      "end": "Alert End",
      "name": "Alert Name",
      "recommended_action": "Recommended Action",
      "severity": "Severity",
      "site": "Site",
      "start": "Alert Start",
      "vpn": "VPN"
    },
    "download": {
      "button": "Export as CSV"
    },
    "filters": {
      "circuit": "Circuit",
      "circuit_usage": "Circuit usage",
      "company_id": "Company",
      "path": "Alerts > Alerts table",
      "risk_description_id": "Name",
      "severity": "Severity",
      "site_id": "Site"
    },
    "no_data": "No Alerts Available",
    "sub_row": {
      "action": "Recommended action: ",
      "content": "Alert content: "
    },
    "subrecords": {
      "error": "Unable to load sub-records for this alert."
    }
  },
  "widgets": {
    "chart_total": {
      "alert_type": {
        "down": "Disconnected",
        "high": "High severity",
        "low": "Low severity",
        "medium": "Medium severity"
      },
      "title_active": "Active alerts",
      "title_resolved": "Resolved alerts",
      "tooltip": {
        "down": "No connectivity detected - all circuits are down",
        "high": "Critical issue that needs immediate attention",
        "low": "Issue to monitor but typically not serious",
        "medium": "Issue that needs attention but is not critical"
      },
      "total_label": "Total"
    },
    "in_time": {
      "alert_type": {
        "down": "Site outage",
        "high": "High",
        "low": "Low",
        "medium": "Medium"
      },
      "title_active": "Active alerts in time",
      "title_resolved": "Resolved alerts in time",
      "tooltip": {
        "description_active": "The number of active alerts generated over the selected time period, organized by severity level",
        "description_resolved": "The number of resolved alerts generated over the selected time period, organized by severity level"
      }
    }
  }
}
